export default __webpack_public_path__ + "static/media/10-3.76c9eec0.jpg";